import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  AlertCircle,
  ArrowLeft,
  CreditCard,
  RefreshCw,
  ShieldCheck,
} from "lucide-react";

export default function PaymentFailed() {
  return (
    <div className="min-h-screen bg-cream">
      <div className="mx-auto flex min-h-screen max-w-7xl items-center justify-center px-6 py-16 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          className="w-full max-w-2xl rounded-[2rem] border border-ink/10 bg-white p-8 shadow-sm md:p-12"
          data-testid="payment-failed-page"
        >
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-peach">
            <AlertCircle
              size={40}
              className="text-hotpink"
              strokeWidth={2.4}
            />
          </div>

          <p className="mt-8 text-center text-xs font-bold uppercase tracking-[0.25em] text-hotpink">
            Payment Failed
          </p>

          <h1 className="mt-3 text-center font-display text-4xl tracking-tighter md:text-5xl">
            We couldn't complete
            <br />
            your payment.
          </h1>

          <p className="mx-auto mt-5 max-w-xl text-center text-ink/65">
            Your payment could not be completed successfully. This can happen
            because of a declined card, UPI timeout, network interruption or
            temporary payment gateway issue.
          </p>

          <div className="mt-10 rounded-3xl border border-ink/10 bg-cream p-6">
            <p className="text-sm font-semibold text-ink">
              Before trying again
            </p>

            <ul className="mt-4 space-y-3 text-sm text-ink/65">
              <li className="flex gap-3">
                <ShieldCheck
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Check your internet connection.
              </li>

              <li className="flex gap-3">
                <ShieldCheck
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Verify your UPI app or bank balance.
              </li>

              <li className="flex gap-3">
                <ShieldCheck
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                If money was deducted but your plan wasn't activated, contact
                support with your Razorpay payment ID.
              </li>
            </ul>
          </div>

          <div className="mt-10 flex flex-col gap-4 md:flex-row">
            <Link
              to="/plans"
              data-testid="retry-payment"
              className="cta-glow inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-sunset-gradient px-6 py-3 text-sm font-semibold text-white"
            >
              <RefreshCw size={16} />
              Try Payment Again
            </Link>

            <Link
              to="/dashboard"
              data-testid="payment-dashboard"
              className="inline-flex flex-1 items-center justify-center gap-2 rounded-full border border-ink/10 bg-white px-6 py-3 text-sm font-semibold text-ink hover:bg-ink/5"
            >
              <ArrowLeft size={16} />
              Back to Dashboard
            </Link>
          </div>

          <div className="mt-8 rounded-2xl bg-mint p-4">
            <div className="flex items-start gap-3">
              <CreditCard
                size={18}
                className="mt-0.5 text-hotpink"
              />
              <div>
                <p className="font-semibold text-ink">
                  Secure payments
                </p>

                <p className="mt-1 text-sm text-ink/65">
                  All payments are securely processed by Razorpay. Checkout DM
                  never stores your card or UPI credentials.
                </p>
              </div>
            </div>
          </div>

          <p className="mt-8 text-center text-xs text-ink/50">
            Need help? Contact support with your payment reference for faster
            assistance.
          </p>
        </motion.div>
      </div>
    </div>
  );
}